import logoDark from '@/assets/images/logo-dark.png'

interface LogoIconProps {
  size?: number
  className?: string
  priority?: boolean
  alt?: string
  style?: React.CSSProperties
}

export default function LogoIcon({
  size = 34,
  className,
  alt = 'ManaPNL Logo',
  style,
}: LogoIconProps) {
  return (
    // Plain img keeps the root layout chunk light; next/image client code was timing out in dev.
    <img
      src={typeof logoDark === 'string' ? logoDark : logoDark.src}
      alt={alt}
      width={size}
      height={size}
      className={className}
      decoding="async"
      style={{ objectFit: 'contain', ...style }}
    />
  )
}
